import { GppBad as GppBadIcon } from '@mui/icons-material';

const Unverified = (): JSX.Element => <GppBadIcon fontSize="inherit" />;

export default Unverified;
